import React from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { TextArea } from '@dropbox/dig-components/text_fields';
import { RadioButton } from '@dropbox/dig-components/controls';
import { Text } from '@dropbox/dig-components/typography';
import { ReasonProps, values } from './types';
import styles from '../survey.module.scss';
import classnames from 'classnames';

const messages = defineMessages({
  otherPlaceholder: {
    id: '',
    description:
      'Placeholder text for a text area when users can provide more information about why they are cancelling their subscription.',
    defaultMessage: "I'm canceling because ...",
  },
});

function CancelReasonOther({ contextRef, ...props }: ReasonProps) {
  const intl = useIntl();

  return (
    <div className={styles.reason}>
      <div className={styles.reasonGroup}>
        <RadioButton
          {...props}
          className={styles.otherRadioButton}
          data-qa-ref="cancel-subscription-survey-reason-other"
          id="cancel-subscription-survey__radio-other"
          name="reason"
          value={values.OTHER}
        />
        <div className={styles.contextContainer}>
          <Text
            tagName="label"
            htmlFor="cancel-subscription-survey__radio-other"
          >
            <FormattedMessage
              id=""
              description="An option the user can select when explaining why s/he is canceling their subscription."
              defaultMessage="Other"
            />
          </Text>
          {props.checked && (
            <div
              className={classnames(styles.reasonContext, styles.otherContext)}
            >
              <TextArea
                data-qa-ref="cancel-subscription-survey-reason-other-context"
                ref={contextRef}
                id="cancel-subscription-survey__context-other"
                rows={3}
                placeholder={intl.formatMessage(messages.otherPlaceholder)}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default CancelReasonOther;
